import type { ReactNode } from "react";
import { ThemeProvider } from "styled-components";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { ToastProvider } from "@/components/ui";
import { GlobalStyle } from "@/styles/GlobalStyle";
import { theme } from "@/styles/theme";

/**
 * 在浏览器和 SSR 两侧都一致包裹的根 Provider。
 *
 * 如果 gatsby-browser 和 gatsby-ssr 不使用相同的树，服务器渲染的标记与
 * 客户端渲染的标记将不一致，导致 hydration 失败。
 */
export function RootProvider({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      {/* 由于备选界面也需要使用主题，因此将其放在 ThemeProvider 内部。 */}
      <ErrorBoundary>
        <ToastProvider>{children}</ToastProvider>
      </ErrorBoundary>
    </ThemeProvider>
  );
}
